import { AfterViewInit, Component, computed, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';
import { StorageService } from '../../services/storage.service';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { HeaderComponent } from '../../components/header/header';
import { MoreInfoComponent } from '../../components/more-info/more-info';
import { App_Routes } from '../../enums/router.enum';
import { SupportedLanguage } from '../../enums/i18.enum';
import { LP_UI_CONFIG } from '../../core/tokens';
// import { DesktopHeaderComponent } from '../../../public-api';
import { CookieBannerService } from '../../services/cookie-banner-service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.html',
  imports: [
    HeaderComponent,
    MoreInfoComponent,
    NzTooltipModule,
    //DesktopHeaderComponent,
  ],
  styleUrls: ['./settings.scss'],
})
export class SettingsComponent implements AfterViewInit, OnInit {
  // 1. Inject dependencies using the `inject` function
  public readonly cfg = inject(LP_UI_CONFIG);
  public router = inject(Router);
  public auth = inject(AuthenticationService);
  public route = inject(ActivatedRoute);
  public ui = inject(UiService);
  public i18n = inject(I18nService);
  public storage = inject(StorageService);
  // private appComponent = inject(AppComponent);
  public cookieBannerService = inject(CookieBannerService);

  public isMobile = computed(() => this.ui.IsMobile());

  public EquipmentMonitorURL = computed(
    () =>
      this.cfg.prefix_equipment_monitor_uri +
      '/login/refauth/' +
      encodeURIComponent(this.storage.token())
  );

  public InstallationAgentURL = computed(
    () =>
      this.cfg.prefix_installation_agent_uri +
      '/login/refauth/' +
      encodeURIComponent(this.storage.token())
  );

  // public IsSSO = computed(() => this.auth.IsSSOUser());

  ngAfterViewInit(): void {
    this.ui.updateTabIndex(this.route.snapshot.data['tabIndex']);
    this.ui.updateBackBtn(this.route.snapshot.data['backBtn']);
  }

  ngOnInit() {
    this.ui.updateBackBtn(false);
    this.ui.setBackText(this.i18n.langString('home'));
  }

  toSubpage(url: string) {
    this.router.navigate(['settings/' + url]);
  }

  toLoctitePulseapp(url: string): void {
    try {
      const parsed = new URL(url);

      const allowedOrigins = [
        new URL(this.cfg.prefix_equipment_monitor_uri).origin,
        new URL(this.cfg.prefix_installation_agent_uri).origin,
      ];

      if (!allowedOrigins.includes(parsed.origin)) {
        return;
      }

      const safeUrl = parsed.toString();

      window.location.assign(safeUrl);
    } catch {
      console.error('Invalid redirect URL');
    }
  }

  logout() {
    this.auth.logout(() => {
      this.router.navigate([App_Routes.LOGIN]);
    });
  }

  goToEquipmentMonitor() {
    // DEPRECATED!
    window.location.href =
      this.cfg.equipment_monitor_uri +
      '/login/refauth/' +
      encodeURIComponent('Bearer ' + this.storage.token());
  }

  toTermsOfService() {
    if (this.i18n.languageSignal() === SupportedLanguage.DE) {
      window.open('https://www.henkel-adhesives.com/de/de/about/terms-of-use.html', '_blank');
    } else {
      window.open('https://www.henkel-adhesives.com/de/en/about/terms-of-use.html', '_blank');
    }
  }

  private isAllowedUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);

      const allowedHosts = [
        new URL(this.cfg.prefix_equipment_monitor_uri).hostname,
        new URL(this.cfg.prefix_installation_agent_uri).hostname,
        new URL(this.cfg.equipment_monitor_uri).hostname,
      ];

      return allowedHosts.includes(parsedUrl.hostname);
    } catch {
      return false;
    }
  }
}
